import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

// Public Route - redirect to dashboard if already authenticated as existing vendor
export const PublicRoute = ({ children }) => {
    const { loading, isExistingVendor } = useAuth();
    
    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
            </div>
        );
    }
    
    // If user is an existing vendor, redirect to dashboard
    if (isExistingVendor()) {
        return <Navigate to="/dashboard" replace />;
    }
    
    return children;
};

// Registering Vendor Route - only accessible during registration process
export const RegisteringVendorRoute = ({ children }) => {
    const { loading, isRegisteringVendor } = useAuth();
    
    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
            </div>
        );
    }
    
    // If not a registering vendor, redirect to register page
    if (!isRegisteringVendor()) {
        return <Navigate to="/register" replace />;
    }
    
    return children;
};

// Existing Vendor Route - only accessible to authenticated existing vendors
export const ExistingVendorRoute = ({ children }) => {
    const { loading, isExistingVendor } = useAuth();
    
    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
            </div>
        );
    }
    
    // If not an existing vendor, redirect to login
    if (!isExistingVendor()) {
        return <Navigate to="/login" replace />;
    }
    
    return children;
};

// Any Authenticated Route - accessible to both registering and existing vendors
export const AuthenticatedRoute = ({ children }) => {
    const { loading, isAuthenticated } = useAuth();
    
    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
            </div>
        );
    }
    
    // If not authenticated at all, redirect to login
    if (!isAuthenticated()) {
        return <Navigate to="/login" replace />;
    }
    
    return children;
}; 